import React, { useEffect } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { AgGridReact } from 'ag-grid-react';
import { useDispatch } from 'react-redux';
import { useSelectedView } from 'reducers/viewsSlice';
import {
  ONE_ON_ONE_INSIGHTS_GROUP_BY_KEYS,
  setGroupByKeysOneOnOneInsightsFilters,
  useOneOnOneInsightsFiltersData,
  setFilterTextOneOnOneInsightsFilters,
} from 'screens/oneOnOneRabbit/Insights/slice/OneOnOneInsightsFiltersSlice';

import { sendSelectedGroupByEvent } from 'constants/mixpanelHelper';

import { AgGridSearch } from 'uiToolkitV1/AgGridWrapperV2';
import { AgGirdDownloadMenu } from 'uiToolkitV1/AgGridWrapperV2/components/DownloadMenu/AgGirdDownloadMenu';
import { Select } from 'uiToolkitV1/Select';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

interface Props {
  downloadCSV: ({ exportedRows }: { exportedRows: 'all' | 'filteredAndSorted' }) => void;
  showGroupBy?: boolean;
  gridRef: React.RefObject<AgGridReact>;
  showDownloadButton?: boolean;
}

const FilterBar = ({ downloadCSV, showGroupBy = false, gridRef, showDownloadButton = true }: Props) => {
  const selectedCohort = useSelectedView();
  const dispatch = useDispatch();
  const options = ONE_ON_ONE_INSIGHTS_GROUP_BY_KEYS;
  const { groupByKeys, filterText } = useOneOnOneInsightsFiltersData();
  const selectedValue = options?.find((key) => key?.value?.keyName === groupByKeys?.keyName);

  const onFilterChangeHandler = ({ value }) => {
    dispatch(
      setFilterTextOneOnOneInsightsFilters({
        filterText: value,
      })
    );
  };

  const onChangeHandler = ({ value }) => {
    sendSelectedGroupByEvent({
      eventProperties: {
        source: '1:1s',
        type: value?.displayName,
      },
    });
    dispatch(
      setGroupByKeysOneOnOneInsightsFilters({
        groupByKeys: value,
      })
    );
  };

  useEffect(() => {
    // clearing filter text when other table is mounted
    dispatch(
      setFilterTextOneOnOneInsightsFilters({
        filterText: '',
      })
    );
  }, [selectedCohort]);

  return (
    <Flex alignItems="center">
      <Box mr="auto" mb="16px">
        <AgGridSearch placeholder="Search" cohortId={selectedCohort?.id} gridRef={gridRef} />
      </Box>
      {showGroupBy && (
        <Flex>
          <TextBodyMedium w="100px" bold color="text.g3">
            Group By
          </TextBodyMedium>
          {/* @ts-ignore */}
          <Select minWidth="150px" options={options} value={selectedValue} handleChange={onChangeHandler} />
        </Flex>
      )}

      {showDownloadButton && (
        <AgGirdDownloadMenu
          options={[
            {
              description: "Download the selected metrics for filtered list of 1:1's",
              title: 'Current View Download',
              isDisabled: false,
              onClick: () =>
                downloadCSV({
                  exportedRows: 'filteredAndSorted',
                }),
            },
            {
              description: "Download all the metrics for all the 1:1's",
              title: 'Detailed Download',
              isDisabled: false,
              onClick: () =>
                downloadCSV({
                  exportedRows: 'all',
                }),
            },
          ]}
        />
      )}

      {/* <Flex
        alignItems="center"
        justifyContent="center"
        borderRadius="4px"
        width="40px"
        height="40px"
        onClick={downloadCSV}
      >
        <DownloadIcon style={{ cursor: 'pointer' }} />
      </Flex> */}
    </Flex>
  );
};

export { FilterBar };
